import React from 'react'
import { getAppURL } from '../../utils/io'

export default ({ appId, name }) => (
  <span className="preview-app-icon-wrapper">
    <img
      src={`${getAppURL(appId)}/icon?size=120`}
      alt={name}
      className="preview-app-icon"
    />
  </span>
)
